<template>
  <v-flex class="section-1 general-bg" ma-0 pt-4 px-4>
    <!-- TITLE -->
    <h3 class="text-xs-left pt-2">Alertas movimiento sin autorización</h3>
    <h4 class="text-xs-left pt-2">Reporte por Vehículo</h4>
    <v-layout>
      <!-- SEARCH VEHICLE -->
      <v-flex class="section-left" mt-3 px-1 pb-2>
        <v-text-field
          v-model="searchVehicleValue"
          ref="search"
          flat
          box
          prepend-inner-icon="search"
          color="white"
          label="Código/Sigla ó Placa"
          @keyup.enter="searchVehicle"
          @change="searchVehicle"
        >
        </v-text-field>
        <v-flex v-if="showOk">
          <v-icon color="green">check_circle</v-icon> Vehículo Disponible
        </v-flex>
        <v-flex v-else-if="showStop">
          <v-icon color="red">not_interested</v-icon> Vehículo No Disponible
        </v-flex>
        <!-- MIN VALUES -->
        <v-flex v-if="showOk" pt-3>
          <v-flex>
            <v-subheader class="pt-0 pl-0">
              {{ `Duración mínima del movimiento sin autorización (${timeType === 1 ? 'segundos' : 'minutos'})` }}
            </v-subheader>
            <v-radio-group v-model="timeType" row @change="changesTimeType">
              <v-radio
                label="Segundos"
                :value="1"
              ></v-radio>
              <v-radio
                label="Minutos"
                :value="2"
              ></v-radio>
            </v-radio-group>
            <v-slider
              v-model="minTime"
              class="pt-3"
              :min="timeType === 1 ? 24 : 3"
              :max="timeType === 1 ? 179 : 120"
              always-dirty
              persistent-hint
              thumb-label="always"
              thumb-size="32"
              prepend-inner-icon="av_timer"
            ></v-slider>
          </v-flex>
        </v-flex>
      </v-flex>
      <!-- DATE & TIME -->
      <v-flex d-flex class="section-right" mt-3 ml-4 v-if="showOk">
        <!-- DATE INTERVAL FOR DATE1 -->
        <v-flex class="section-right-in" xs6 mr-3>
          <v-flex>
            <v-menu
              v-model="menu1"
              ref="menu1"
              lazy
              transition="scale-transition"
              offset-x
              left
              full-width
              origin="top left"
              nudge-right="300"
              nudge-top="-40"
              color="white"
              :close-on-content-click="false"
              :return-value.sync="dates1"
            >
              <template v-slot:activator="{ on }">
                <v-combobox
                  v-model="dates1"
                  multiple
                  chips
                  small-chips
                  box
                  label="Escoger el día inicial"
                  prepend-inner-icon="event"
                  readonly
                  color="white"
                  v-on="on"
                ></v-combobox>
              </template>
              <v-date-picker
                v-model="dates1"
                multiple
                no-title
                scrollable
                color="blue accent-3"
                locale="es-sp"
                :first-day-of-week="1"
                :allowed-dates="allowedDates1"
                @input="changesOnDate1"
              >
                <v-spacer></v-spacer>
                <v-btn color="error" @click="menu1 = false">Cancelar</v-btn>
                <v-btn color="primary" @click="$refs.menu1.save(dates1)">Aceptar</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <!-- SELECT TIMES DATE 1-->
          <v-flex v-if="dates1.length > 0">
            <!-- TIME 1 DATE 1 -->
            <v-flex class="container-date-1" py-2 d-inline-flex px-5 align-center>
              <v-flex>
                <v-icon>event</v-icon>
              </v-flex>
              <v-flex pl-1>
                Fecha Inicial:
              </v-flex>
              <v-flex class="style-date-h" pl-2>
                {{ dates1[0] | moment("DD/MM/YYYY") }}
              </v-flex>
            </v-flex>
            <!-- MENU TIME 1 DATE 1 -->
            <v-flex mt-3>
              <v-menu
                v-model="time1Date1Menu"
                ref="time1Date1Menu"
                class="mx-1"
                lazy
                transition="scale-transition"
                offset-x
                left
                full-width
                allow-overflow
                min-width="290px"
                origin="top left"
                nudge-right="750"
                nudge-bottom="0"
                :close-on-content-click="false"
                :return-value.sync="time1Date1"
              >
                <v-text-field
                  v-model="time1Date1"
                  label="Hora Inicial"
                  slot="activator"
                  placeholder="Seleccionar Hora"
                  prepend-inner-icon="av_timer"
                  readonly
                  box
                  hide-details
                  color="white"
                  clearable
                  @click:clear="clearTime1Date1"
                />
                <v-time-picker
                  v-model="time1Date1"
                  landscape
                  format="24hr"
                  scrollable
                  color="teal darken-1"
                  header-color="grey darken-4"
                  :allowed-hours="allowedHours0"
                  :allowed-minutes="allowedMinutes0"
                  @input="changesOnTime1Date1"
                >
                  <v-spacer></v-spacer>
                  <v-btn color="error" @click="time1Date1Menu = false">Cancelar</v-btn>
                  <v-btn color="primary" @click="acceptTime10">Aceptar</v-btn>
                </v-time-picker>
              </v-menu>
            </v-flex>
            <!-- TIME 2 DATE 1 MENU -->
            <v-flex v-if="time1Date1 !== null && dates2.length === 0" mt-3>
              <v-menu
                v-model="time2Date1Menu"
                ref="time2Date1Menu"
                class="mx-1"
                lazy
                transition="scale-transition"
                offset-x
                left
                full-width
                min-width="290px"
                origin="top left"
                nudge-right="750"
                nudge-bottom="0"
                :close-on-content-click="false"
                :return-value.sync="time2Date1"
              >
                <v-text-field
                  v-model="time2Date1"
                  label="Hora Final"
                  placeholder="Seleccionar Hora"
                  slot="activator"
                  prepend-inner-icon="av_timer"
                  readonly
                  box
                  hide-details
                  color="white"
                  clearable
                />
                <v-time-picker
                  v-model="time2Date1"
                  landscape
                  format="24hr"
                  scrollable
                  color="red darken-1"
                  header-color="grey darken-4"
                  :allowed-hours="allowedHours1"
                  :allowed-minutes="allowedMinutes1"
                >
                  <v-spacer></v-spacer>
                  <v-btn color="error" @click="time2Date1Menu = false">Cancelar</v-btn>
                  <v-btn color="primary" @click="$refs.time2Date1Menu.save(time2Date1)">Aceptar</v-btn>
                </v-time-picker>
              </v-menu>
            </v-flex>
          </v-flex>
        </v-flex>
        <!-- ////////////////////////////////////////////////////////// -->
        <!-- DATE INTERVAL FOR DATE2 -->
        <!-- ////////////////////////////////////////////////////////// -->
        <v-flex
            v-if="time1Date1 !== null && dates1.length > 0 && !time1Date1IsToday"
            class="section-right-in"
            xs6
            ml-3
          >
          <v-flex>
            <v-menu
              v-model="menu2"
              ref="menu2"
              transition="scale-transition"
              lazy
              offset-x
              left
              full-width
              origin="top left"
              nudge-right="300"
              nudge-top="-40"
              color="white"
              :close-on-content-click="false"
              :return-value.sync="dates2"
            >
              <template v-slot:activator="{ on }">
                <v-combobox
                  v-model="dates2"
                  label="Escoger el día final"
                  multiple
                  chips
                  small-chips
                  box
                  prepend-inner-icon="event"
                  readonly
                  color="white"
                  v-on="on"
                ></v-combobox>
              </template>
              <v-date-picker 
                v-model="dates2"
                multiple
                no-title
                scrollable
                locale="es-sp"
                color="blue accent-3"
                :first-day-of-week="1"
                :allowed-dates="allowedDates2"
                @input="changesOnDate2"
              >
                <v-spacer></v-spacer>
                <v-btn color="error" @click="menu2 = false">Cancelar</v-btn>
                <v-btn color="primary" @click="$refs.menu2.save(dates2)">Aceptar</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <!-- SELECT TIME DATE 2-->
          <v-flex v-if="!!dates2[0]">
            <!-- TIME 1 DATE 2 -->
            <v-flex
              class="container-date-2"
              d-inline-flex
              align-center
              py-2
              px-5
            >
              <v-flex>
                <v-icon>event</v-icon>
              </v-flex>
              <v-flex pl-1>
                Fecha Final:
              </v-flex>
              <v-flex class="style-date-h" pl-2>
                {{ dates2[0] | moment("DD/MM/YYYY") }}
              </v-flex>
            </v-flex>
            <!-- MENU TIME 1 DATE 2 -->
            <v-flex mt-3>
              <v-menu
                v-model="time1Date2Menu"
                ref="time1Date2Menu"
                class="mx-1"
                lazy
                transition="scale-transition"
                offset-x
                left
                full-width
                allow-overflow
                min-width="290px"
                origin="top left"
                nudge-right="750"
                nudge-bottom="0"
                :close-on-content-click="false"
                :return-value.sync="time1Date2"
              >
                <v-text-field
                  v-model="time1Date2"
                  label="Hora Final"
                  placeholder="Seleccionar Hora"
                  slot="activator"
                  prepend-inner-icon="av_timer"
                  readonly
                  box
                  hide-details
                  color="white"
                  clearable
                />
                <v-time-picker
                  v-model="time1Date2"
                  landscape
                  format="24hr"
                  scrollable
                  color="red darken-1"
                  header-color="grey darken-4"
                  :allowed-hours="allowedHours2"
                  :allowed-minutes="allowedMinutes2"
                  @click:hour="clickHourTime1Date2"
                  @click:minute="clickMinuteTime1Date2"
                >
                  <v-spacer></v-spacer>
                  <v-flex class="text-xs-center">
                    <v-btn color="error" @click="time1Date2Menu = false">Cancelar</v-btn>
                    <v-btn color="primary" @click="$refs.time1Date2Menu.save(time1Date2)">Aceptar</v-btn>
                  </v-flex>
                </v-time-picker>
              </v-menu>
            </v-flex> 
          </v-flex>
        </v-flex>
      </v-flex>
    </v-layout>
    <!-- MESSAGE -->
    <v-layout v-if="showOk" align-start justify-center mt-4>
      <p style="min-width:450px;max-width:450px;" class="text-xs-center">
        <v-icon>warning</v-icon>
        La información contenida en los reportes por Movimientos sin autorización, corresponde a las alertas mostradas en el panel de control en tiempo real, según las condiciones de funcionamiento de la minuta de servicio.
      </p>
    </v-layout>
    <!-- BUTTON -->
    <v-layout v-if="showOk" justify-center mt-1 pb-2>
      <v-flex style="max-width:250px;min-width:250px;">
        <v-btn
          v-if="!reportReadyGRMAV"
          target="_blank"
          color="primary"
          block
          :disabled="reportTimeDisabled"
          :loading="$loading.isLoading('generatingReportMovementAlarmsVehicle')"
          @click="getReport"
        >
          <v-icon left>description</v-icon>
          Generar Reporte
        </v-btn>
        <v-btn
          v-if="reportReadyGRMAV"
          :href="urlReportGRMAV"
          target="_blank"
          color="success"
          block
          @click="downloadReport(toggleBtnGRMAV(false))"
        >
          <v-icon left>cloud_download</v-icon>
          Descargar Reporte
        </v-btn>
      </v-flex>
    </v-layout>
    <!-- CLEAR FORM -->
    <v-layout
      v-if="showClearForm"
      justify-center
      pb-3
    >
      <v-flex style="max-width:250px;min-width:250px;">
        <v-btn
          color="red"
          block
          @click="clearFormIn"
        >
          <v-icon left>clear</v-icon>
          Limpiar Datos
        </v-btn>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { reportsMixin2 } from '../../mixins/reportsMixin2.js'

export default {
  name: 'report-movement-alarms-vehicle',
  mixins: [reportsMixin2],
  data() {
    return {
      timeType: 1,
      minTime: 24
    }
  },
  computed: {
    ...mapGetters(['reportReadyGRMAV', 'urlReportGRMAV'])
  },
  methods: {
    ...mapActions(['getReportMovementAlarmsVehicle', 'toggleBtnGRMAV']),
    getReport() {
      let startDate = `${this.dates1[0]} ${this.time1Date1}`
      let endDate = this.dates2.length === 1
        ? `${this.dates2[0]} ${this.time1Date2}`
        : `${this.dates1[0]} ${this.time2Date1}`
      const params = {
        startDate,
        endDate,
        minDuration: this.timeType === 1 ? this.minTime : this.minTime * 60
      }
      const payload = {
        id: this.searchVehicleResult[0].id,
        params
      }
      this.getReportMovementAlarmsVehicle(payload)
    },
    changesTimeType() {
      this.minTime = this.timeType === 1 ? 24 : 3
    },
    clearFormIn() {
      this.minTime = 24
      this.timeType = 1
      this.clearForm()
    }
  }
}
</script>

<style lang="stylus" scoped>
h3
  font-size 30px
  font-weight 500
  line-height 28px

h4
  font-size 21px
  font-weight 500

.section-1
  min-width max-content
  
.general-bg
  background-color #424242
  border-radius 3px

.section-left
  min-width 270px
  max-width 270px

.section-right-in
  min-width 325px
  max-width 325px

.section-right
  min-width max-content

.container-date-1
  background-color #00897B
  border-radius 30px

.container-date-2
  background-color #E53935
  border-radius 30px

.style-date-h
  font-weight 600
  font-size 16px
</style>


// WEBPACK FOOTER //
// src/components/Reports/ReportMovementAlarmsVehicle.vue